import React from 'react';
import { IconButton } from '../../../../common/controls/Controls';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';

const CustomToolbar = (props) => {
  const { onNavigate, label } = props;

  return (
    <div className="toolbar-container">
      <div className="month-container">
        <div className="month-wrapper">{label}</div>

        <div className="chevron-wrapper">
          <IconButton
            icon={<LeftOutlined />}
            onClick={() => {
              onNavigate('PREV');
            }}
            style={{ style: { color: 'white' } }}
          />
          <IconButton
            icon={<RightOutlined />}
            onClick={() => onNavigate('NEXT')}
            style={{ style: { color: 'white' } }}
          />
        </div>
      </div>
    </div>
  );
};

export default CustomToolbar;
